import React from 'react';
import { SearchX } from 'lucide-react';

/**
 * Empty state when search/filters return no results (Pirucat mascot copy).
 */
function EmptySearchPirucat({ onClearFilters }) {
  return (
    <div className="exam-dashboard__empty">
      <div className="exam-dashboard__empty-icon">
        <SearchX width={32} height={32} aria-hidden />
      </div>
      <p className="exam-dashboard__empty-title">Pirucat couldn&apos;t find any exams</p>
      <p className="exam-dashboard__empty-text">
        Pirucat searched the whole catalog and there are no matches for your search or filters.
        Try different keywords or broaden category and difficulty.
      </p>
      {onClearFilters ? (
        <button type="button" onClick={onClearFilters} className="exam-dashboard__btn-secondary">
          Clear search and filters
        </button>
      ) : null}
    </div>
  );
}

export default EmptySearchPirucat;
